import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Mail, ArrowLeft } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      toast.error(t('errors.enterEmail'));
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success(t('auth.emailSent'));
    } catch (error) {
      console.error('Forgot password error:', error);
      toast.error(error.response?.data?.detail || t('errors.sendError'));
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <Mail size={32} style={{ color: '#22c55e' }} />
            <h1>{t('auth.checkYourEmail')}</h1>
            <p style={{ marginTop: '1rem', lineHeight: '1.6' }}>
              {t('auth.ifEmailRegistered')} <strong>{email}</strong>, {t('auth.youWillReceiveInstructions')}
            </p>
            <p style={{ marginTop: '1rem', color: '#666', fontSize: '0.9rem' }}>
              {t('auth.checkSpamFolder')}
            </p>
          </div>

          <div className="auth-footer" style={{ marginTop: '2rem' }}>
            <Link to="/login" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', justifyContent: 'center' }}>
              <ArrowLeft size={18} />
              {t('auth.backToLogin')}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <Mail size={32} />
          <h1>{t('auth.forgotPassword')}</h1>
          <p>{t('auth.enterEmailToRecover')}</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">{t('auth.email')}</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              disabled={loading}
              autoFocus
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="auth-submit-btn"
          >
            {loading ? t('common.sending') : t('auth.sendLink')}
          </Button>
        </form>

        <div className="auth-footer">
          <p>
            {t('auth.rememberPassword')}{' '}
            <Link to="/login">
              {t('auth.login')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
